/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, dose: NonNullable<unknown> }} Plan_Build_Dose_Saved_ToastInputs */

const en_us2_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.dose}`)
};

const pt_br2_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.dose}`)
};

const es_419_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.dose}`)
};

const pt_pt2_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.dose}`)
};

const fr_fr2_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} : ${i?.dose}`)
};

const de_de2_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.dose}`)
};

const it_it2_plan_build_dose_saved_toast = /** @type {(inputs: Plan_Build_Dose_Saved_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.dose}`)
};

/**
* | output |
* | --- |
* | "{name}: {dose}" |
*
* @param {Plan_Build_Dose_Saved_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_saved_toast = /** @type {((inputs: Plan_Build_Dose_Saved_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_Saved_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_saved_toast(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_saved_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_saved_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_saved_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_saved_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_saved_toast(inputs)
	return en_us2_plan_build_dose_saved_toast(inputs)
});
export { plan_build_dose_saved_toast as "plan-build.dose_saved_toast" }